import { render, staticRenderFns } from "./SPREventOrganizersDropdown.vue?vue&type=template&id=71a30c02"
import script from "./SPREventOrganizersDropdown.vue?vue&type=script&lang=js"
export * from "./SPREventOrganizersDropdown.vue?vue&type=script&lang=js"
import style0 from "./SPREventOrganizersDropdown.vue?vue&type=style&index=0&id=71a30c02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports